module.exports = __webpack_public_path__ + "img/close.daa39a36.svg";